jQuery(document).ready(function ($) {

    resizeWhoWeAre();
    window.onresize = function (){
        resizeWhoWeAre();
    }

});

function resizeWhoWeAre() {
    if($(document).width() > 767) {
        let whoWeAreRight = $('<div class="who_we_are_right"><div class="who_we_are__list"></div></div>');


        let items = $('.who_we_are .who_we_are__list .who_we_are_item');
        let itemsToMove = items.slice(2, 5).get().reverse();

        if(itemsToMove.length > 0){
            whoWeAreRight.appendTo($('.wrapper_who_we_are'));
            whoWeAreRight.find('.who_we_are__list').append(itemsToMove);
        }
    } else {
        $('.who_we_are_right .who_we_are__list > *').appendTo($('.who_we_are .who_we_are__list'));
        $('.who_we_are_right').remove();
    }
}
